import { render, staticRenderFns } from "./VocabularyCard.vue?vue&type=template&id=e741b84e&"
import script from "./VocabularyCard.vue?vue&type=script&lang=js&"
export * from "./VocabularyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VocabularyCard.vue"
export default component.exports